import { URLASSOLUTO, URLASSOLUTOISTITUZIONALE } from "./variables";
import Swal from "./sweetalert2";
import bootstrapvalidation from "./validate";

//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...
$("html").addClass("is-loading");

$(document).ready(function () {


    $(".headeraccordion").on("click", function () {
        let $accordion = $(this).next(".bodyAccordion");
        let $icon = $(this).find(".fa-plus, .fa-minus"); // Seleziona entrambi i simboli

        // Chiudi tutti gli altri accordion
        $(".bodyAccordion").not($accordion).slideUp();
        $(".headeraccordion").not(this).removeClass("open")
            .find(".fa-minus").removeClass("fa-minus").addClass("fa-plus"); // Reset icona

        // Alterna lo stato dell'accordion cliccato
        if ($accordion.is(":visible")) {
            $accordion.slideUp();
            $icon.removeClass("fa-minus").addClass("fa-plus"); // Torna a +
            $(this).removeClass("open");
        } else {
            $accordion.slideDown();
            $icon.removeClass("fa-plus").addClass("fa-minus"); // Cambia in -
            $(this).addClass("open");
        }
    });


    $("body").on("click", ".showSubmenu", function () {
        $(this).closest('li').toggleClass('active');
    });


    let hash = window.location.hash;
    if ($(hash + "L").length) {
        $("html, body").animate(
            {
                scrollTop: $(hash + "L").offset().top,
            },
            1000
        );
    }
    if (hash === "#lavoraconnoi" && $(".bloccoformcontatti").length) {
        $("#tab2").attr("checked", true);
        $(".labellavoraconnoi").trigger("click");
        $("html, body").animate(
            {
                scrollTop: $(".bloccoformcontatti").offset().top,
            },
            1000
        );
    }

    // fade out background preloader
    $.when(
        $("#preload").fadeOut(function () {
            /*$(".immagine-header.homepage").addClass('isvisible');*/
        })
    ).done(function () {
        $("html").removeClass("is-loading");
        $("html").addClass("is-first-loaded");
        $("html").addClass("is-loaded");
    });

    /*    $('body').on('click', '#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4', function () {
		$('.nav-icon-toggle').toggleClass('open');
        $('body').toggleClass('menuopen');
        $('.menuleft').toggleClass('open');
        $('.menuleft').find('nav').toggleClass('open');
	});
*/



    $("body").on("click", ".annopaperselector", function () {
        $(this).find('.btn-biancointobluscuro2').toggleClass('attivo');
        //console.log($(this), 'aaa');
        if($('.btn-biancointobluscuro2.attivo').length > 0) {
            /*$('.boxpaper').fadeOut();
            $('.btn-biancointoverde2.attivo').each(function (index) {
                let annoselected = $(this).parent().data("annosel");
                //console.log(annoselected, 'bbb');
                $('.boxpaper.annopaper-' + annoselected).fadeIn();
            });
            */
            $('.btn-biancointobluscuro2').each(function (index) {
                let annoselected = $(this).parent().data("annosel");
                if ($(this).hasClass('attivo')) {
                    $('.boxpaper.annopaper-' + annoselected).fadeIn();
                } else {
                    $('.boxpaper.annopaper-' + annoselected).fadeOut();
                }

                //console.log(annoselected, 'bbb');

            });
        } else {
            //$('.boxpaper').removeClass('d-none');
            $('.boxpaper').fadeIn();
        }

    });


    $(".sameheight").css("height", "auto");
    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();
    $("body").on("change", ".languageselector", function () {
        var languageselected = $(this).find(":selected").data("path");
        if (typeof languageselected !== "undefined") {
            window.location.href = languageselected;
        }
    });
    $("body").on("change", ".applicationgroupselecter", function () {
        var applicationgroupselecter = $(this).find(":selected").data("path");
        if (typeof applicationgroupselecter !== "undefined") {
            window.location.href = applicationgroupselecter;
        }
    });
    $("body").on("click", ".calltoactionwwu", function () {
        $("#tab2").attr("checked", true);
        $(".labellavoraconnoi").trigger("click");
        $("html, body").animate(
            {
                scrollTop: $(".bloccoformcontatti").offset().top,
            },
            1000
        );
    });

    $("body").on("keydown", ".ricercainput", function (event) {
        if (event.keyCode === 13) {
            console.log('doricerca');
            // Add your code here
            $(this).closest('form').find('button').trigger('click');
        }
    });
    $("body").on("click", ".doricerca", function (event) {
        console.log('doricerca');
        $(this).closest('form').find('button').trigger('click');
    });

    // When the user scrolls the page, execute myFunction
    window.onscroll = function () {
        StickyFunction();
    };

    // Get the header
    var header = document.getElementById("head");

    // Get the offset position of the navbar
    var sticky = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function StickyFunction() {
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }

	$(document).on("click", "#torna_su", function(e) {
		$('html, body').animate({
			scrollTop: 0
		}, 1000);
	});
});

$(window).on('scroll', function() {
	var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		x = w.innerWidth || e.clientWidth || g.clientWidth,
		y = w.innerHeight || e.clientHeight || g.clientHeight;
	let tornaSu = document.getElementById('torna_su');
	let viewport = $('html, body');
	let viewport2 = $('body');
	let vtop = viewport.scrollTop();
	let vtop2 = viewport2.scrollTop();
	//console.log(vtop);
	if (vtop < 50 && vtop2 < 50) {
		$(tornaSu).fadeOut();
		// nascondo gli errori del validator
		$('.error').css('visibility', 'hidden');
	} else {
		$(tornaSu).fadeIn();
	}
});
$(window).resize(function () {
    $(".sameheight").css("height", "auto");
    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();
});
